var map = {
	"./AdaIDE.dark.png": 4446,
	"./AdaIDE.darkplus.png": 805,
	"./AdaIDE.default.png": 92392,
	"./CCmake.dark.png": 50172,
	"./CCmake.darkplus.png": 18754,
	"./CCmake.default.png": 36460,
	"./DiffofTwoCompilers.dark.png": 39797,
	"./DiffofTwoCompilers.darkplus.png": 63434,
	"./DiffofTwoCompilers.default.png": 37156,
	"./DiffofTwoSources.dark.png": 7056,
	"./DiffofTwoSources.darkplus.png": 14891,
	"./DiffofTwoSources.default.png": 43512,
	"./JavaIDE.dark.png": 44465,
	"./JavaIDE.darkplus.png": 5334,
	"./JavaIDE.default.png": 42920,
	"./LLVMIR.dark.png": 60181,
	"./LLVMIR.darkplus.png": 86874,
	"./LLVMIR.default.png": 70620,
	"./PascalIDE.dark.png": 58088,
	"./PascalIDE.darkplus.png": 11333,
	"./PascalIDE.default.png": 319,
	"./Preprocessor.dark.png": 52241,
	"./Preprocessor.darkplus.png": 49562,
	"./Preprocessor.default.png": 128,
	"./TreeIDEMode.dark.png": 43757,
	"./TreeIDEMode.darkplus.png": 26786,
	"./TreeIDEMode.default.png": 69407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87456;